/* global BigInt */
// Queen Dollar arithmetic, exact (no floating point): the same result the database stores, round(usd × rate, 2)
// with halves rounded away from zero. USD has at most 2 decimals, the rate at most 4.

const DEC = /^\d+(\.\d+)?$/;
const toScaled = (v, places) => {           // "12.5" → 1250n for places = 2; null when not a plain positive decimal
    const s = String(v ?? "").trim();
    if (!DEC.test(s)) return null;
    const [i, f = ""] = s.split(".");
    if (f.length > places) return null;
    return BigInt(i + f.padEnd(places, "0"));
};

export const usdError = (v) => {
    const s = String(v ?? "").trim();
    if (!s) return "Enter the USD amount.";
    if (!DEC.test(s)) return "Use a number, e.g. 125.50.";
    if (toScaled(s, 2) === null) return "Use at most 2 decimals.";
    if (toScaled(s, 2) <= 0n) return "Enter more than 0.";
    if (toScaled(s, 2) > 100000000000n) return "That amount is too large.";
    return "";
};
export const rateError = (v) => {
    const s = String(v ?? "").trim();
    if (!s) return "Enter the NPR rate.";
    if (!DEC.test(s)) return "Use a number, e.g. 153.";
    if (toScaled(s, 4) === null) return "Use at most 4 decimals.";
    if (toScaled(s, 4) <= 0n) return "Enter more than 0.";
    if (toScaled(s, 4) > 1000000000n) return "That rate is too large.";
    return "";
};

// NPR equivalent as a 2-decimal string, or "" when an input is not valid.
export function nprOf(usd, rate) {
    if (usdError(usd) || rateError(rate)) return "";
    const p = toScaled(usd, 2) * toScaled(rate, 4);               // 6 decimals
    const cents = (p + 5000n) / 10000n;                            // round half up (values are positive)
    const s = cents.toString().padStart(3, "0");
    return `${s.slice(0, -2)}.${s.slice(-2)}`;
}

const group = (n, locale) => Number(n).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtUsd = (n) => (n === null || n === undefined || n === "" ? "—" : `USD ${group(n, "en-US")}`);
export const fmtNpr = (n) => (n === null || n === undefined || n === "" ? "—" : `NPR ${group(n, "en-IN")}`);
export const fmtRate = (n) => (n === null || n === undefined || n === "" ? "—" : Number(n).toLocaleString("en-US", { maximumFractionDigits: 4 }));

// Today in Nepal (the database refuses future dates by Kathmandu time).
export const ktmToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kathmandu" }).format(new Date());
